import * as React from 'react';

import CarrosselService from '../../../services/CarrosselService';

import { BaSeDialogContext } from '@base/react';

import { BaSeTheme } from '@base/react';

export const ReorderCarrosselModel = (({
  tipos, data
}) => {

  const [tipo, setTipo] = React.useState(tipos[0]);
  const [dataType, setDataType] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const { showModal } = React.useContext(BaSeDialogContext);

  React.useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await CarrosselService.getDataByType(tipo);
      setDataType(response?.data ?? []);
      setIsLoading(false);
    }

    getData();

  }, [tipo]);

  const updateOrder = (result) => {

    if (!result.destination) return;

    const items = Array.from(dataType);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setDataType(items);
  }

  const saveOrder = async () => {
    const valuesOrdered = dataType.map(({
      id,
      ordem,
      titulo,
      descricao,
      tipo: lolalType
    }) => {
      return {
        id,
        ordem,
        titulo,
        descricao,
        tipo: lolalType
      }
    })

    const response = await CarrosselService.order({ carrosseis: valuesOrdered });

    const Sim = 'OK';
    const actions = {
      [Sim]: () => console.log('Ação do modal: SIM'),
    };
    let config;

    if (response.status !== 200) {
      config = {
        // Entradas
        actions: [
          {
            action: Sim,
            type: 'primary',
            color: BaSeTheme.colors.feedbackInterface.erro45,
          },
        ],
        title: 'Erro',
        titleColor: BaSeTheme.colors.institucionais.erro45,
        dismissable: true,
        content: () => (
          <text> A lista de carrosséis <strong>não foi ordenada</strong>. Ocorreu algum problema.Tente novamente mais tarde!</text>
        ),
        onChooseAction: (action) => actions?.[action]?.(),
      };
    } else {
      config = {
        actions: [
          {
            action: Sim,
            type: 'primary',
            color: BaSeTheme.colors.feedbackInterface.sucesso,
          }
        ],
        title: 'Reordenado',
        titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45,
        dismissable: true,
        content: () => (
          <text>A lista de carrosséis foi  <strong>ordenada</strong> com sucesso. </text>
        ),
        onChooseAction: (action) => actions?.[action]?.(),
      };
    }

    showModal(config);
  }

  return {
    tipo,
    setTipo,
    dataType,
    updateOrder,
    saveOrder,
    isLoading,
  }

})